export interface SelectOption {
  isAny?: boolean
  isOther?: boolean
  label: string
  value: string
}
